'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = require('web3-provider-engine/dist/es5/index');

var _index2 = _interopRequireDefault(_index);

var _fetch = require('web3-provider-engine/dist/es5/subproviders/fetch');

var _fetch2 = _interopRequireDefault(_fetch);

var _filters = require('web3-provider-engine/dist/es5/subproviders/filters');

var _filters2 = _interopRequireDefault(_filters);

var _sanitizer = require('web3-provider-engine/dist/es5/subproviders/sanitizer');

var _sanitizer2 = _interopRequireDefault(_sanitizer);

var _fixture = require('web3-provider-engine/dist/es5/subproviders/fixture');

var _fixture2 = _interopRequireDefault(_fixture);

var _inflightCache = require('web3-provider-engine/dist/es5/subproviders/inflight-cache');

var _inflightCache2 = _interopRequireDefault(_inflightCache);

var _hookedWallet = require('web3-provider-engine/dist/es5/subproviders/hooked-wallet');

var _hookedWallet2 = _interopRequireDefault(_hookedWallet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExternalWalletProvider = function ExternalWalletProvider(options) {
  var _this = this;

  _classCallCheck(this, ExternalWalletProvider);

  this.getAccounts = function (callback) {
    return callback(null, [_this.address]);
  };

  this.signTransaction = function (txData, callback) {
    return callback(null, txData);
  };

  this.address = options.address;
  this.connectionOpened = false;
  this.getAccounts = this.getAccounts.bind(this);
  this.signTransaction = this.signTransaction.bind(this);
};

exports.default = function (rpcUrl) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!options.address) {
      throw new Error('No address provided');
    }
    if (!rpcUrl) {
      throw new Error('Network rpcUrl not provided');
    }
    var engine = new _index2.default();

    // static results
    engine.addProvider(new _fixture2.default({
      web3_clientVersion: 'ProviderEngine/v0.0.0/javascript',
      net_listening: true,
      eth_hashrate: '0x00',
      eth_mining: false,
      eth_subscribe: false
    }));
    engine.addProvider(new _sanitizer2.default());
    engine.addProvider(new _filters2.default());
    engine.addProvider(new _inflightCache2.default());
    engine.addProvider(new _hookedWallet2.default(new ExternalWalletProvider(options)));
    engine.addProvider(new _fetch2.default({ rpcUrl: rpcUrl }));

    engine.start();
    return engine;
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/walletProviders/externalProvider.js
// module id = 1192
// module chunks = 0